import React, { useState, useEffect, useRef } from "react";
import GoogleIcon from '@mui/icons-material/Google';
import { authActions } from "../../../redux-store";
import { ToastContainer, toast } from "react-toastify";
import { CircularProgress } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import sessionstorage from "sessionstorage";
import backend from "../../../api";
import { useNavigate } from "react-router-dom";
// import './Auth.css';
import { useLocation } from 'react-router-dom';
import { motion, easeOut, AnimatePresence } from 'framer-motion';
import Classes from './Auth.module.css'
import CryptoJS from 'crypto-js';
import Logo from "../Home/Components/Logo/Logo";

const LoadingSpinner = () => (
    <div class="loadingio-spinner-eclipse-nq4q5u6dq7r">
        <div class="ldio-x2uulkbinbj">
            <div></div>
        </div>
    </div>
)

function Signup() {
    const [width, setWidth] = useState(window.innerWidth);
    const [state, setState] = useState("signup");
    const { user } = useSelector((state) => state.auth);
    const [companyName, setCompanyName] = useState("");
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [colorScheme, setcolorScheme] = useState('#0A84FF');
    const [confirmPassword, setconfirmPassword] = useState("");
    const [loading, setLoading] = useState();
    const [incorrectError, setincorrectError] = useState(false);
    const dispatch = useDispatch();
    const navigateTo = useNavigate();
    const [showEye, setshowEye] = useState(false);
    const [showEye2, setshowEye2] = useState(false);
    const [passwordMatchingError, setpasswordMatchingError] = useState(false);
    const [emailSentMsg, setemailSentMsg] = useState(false);
    const [invalidEmailError, setinvalidEmailError] = useState(false);
    const [passwordLengthError, setpasswordLengthError] = useState(false);
    const [userAlreadyExistError, setUserAlreadyExistError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [codeSentMsg, setcodeSentMsg] = useState(false);
    const [IncorrectCode, setIncorrectCode] = useState(false);
    const [userCode, setUserCode] = useState('');
    const [userId, setUserId] = useState('');

    const location = useLocation();

    const [imageURL, setImageURL] = useState('');
    const [brochureLoading, setBrochureLoading] = useState(false);

    const imageInputRef = useRef(null);

    const handleClick = () => {
        if (imageInputRef.current) {
            imageInputRef.current.click();
        }
    };

    const handleInputChange = (e) => {
        const files = e.target.files;
        const name = e.target.name;
        // handleFileChange(files, name);
    };

    useEffect(() => {
        if (state === 'signin') {
            navigateTo('/login')
        }
    }, [state])
    const code = Math.floor(Math.random() * 10000).toString();

    const message = `verification code is ${code}`;

    const updateDimensions = () => {
        setWidth(window.innerWidth);
    };

    useEffect(() => {
        window.addEventListener('resize', updateDimensions);
        return () => window.removeEventListener('resize', updateDimensions);
    }, []);

    const switchToSignUp = () => {
        setincorrectError(false);
        setState("signup");
    }

    const switchToVerify = () => {
        setincorrectError(false);
        if (password !== confirmPassword) {
            setpasswordMatchingError(true);
            setTimeout(() => {
                setpasswordMatchingError(false);
            }, 5000);
            return;
        }

        if (password && password.length <= 5) {
            setpasswordLengthError(true);
            setTimeout(() => {
                setpasswordLengthError(false);
            }, 10000);
            return;
        }

        sendMail();
    }

    const switchToSignIn = () => {
        setincorrectError(false);
        setState("signin");
    }

    const sendMail = async () => {
        setLoading(true);

        try {
            const encrypted = CryptoJS.AES.encrypt(code, 'secret-key').toString();
            sessionStorage.setItem('encryptedData', encrypted);
            const encryptedDataFromStorage = sessionStorage.getItem('encryptedData');

            if (encryptedDataFromStorage) {
                const bytes = CryptoJS.AES.decrypt(encryptedDataFromStorage, 'secret-key');
                const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
                // Optionally use decryptedData if needed
            }

            const body = {
                username: "User",
                email: email,
                message
            };
            const resp = await backend.post("/verify/sendemail", body);

            if (resp.status === 200) {
                // console.log('Verification code sent successfully');
                setcodeSentMsg(true);
                setTimeout(() => {
                    setcodeSentMsg(false);
                }, 60000);
                setState('verify');
            } else if (resp.status === 400) {
                setUserAlreadyExistError(true);
                setTimeout(() => {
                    setUserAlreadyExistError(false);
                }, 10000);
            } else if (resp.status === 500) {
                alert('Server error occurred. Please try again later.');
            } else {
                // Handle other unexpected statuses
                alert('An unexpected error occurred. Please try again.');
            }
        } catch (error) {
            // This block will now only catch network errors or issues in the request setup,
            // not HTTP errors like 400 or 500 which are handled above
            console.log(error?.response?.data?.message);
            setUserAlreadyExistError(true);
            setErrorMessage(error?.response?.data?.message);
            setTimeout(() => {
                setUserAlreadyExistError(false);
                setErrorMessage('');
            }, 10000);
            // alert(error?.response?.data?.message);
        } finally {
            setLoading(false);
        }
    };

    const loginSubmitHandler = async (e) => {
        e.preventDefault();
        setincorrectError(false);
        setLoading(true)
        const sideBar = sessionStorage.getItem('navBtn');

        const isLogin = await dispatch(authActions.login(email, password));
        // console.log(dispatch(authActions.login(email, password)))

        if (isLogin) {

            // handleLogout()
            // await getProjectById();
            setLoading(false)
            if (sideBar == "Pitch Deck Templates") {
                navigateTo(`/templates`);
            } else {
                navigateTo("/dashboard");
            }
        }
        if (!isLogin) {
            setLoading(false)
            // alert("Wrong Credentials");
            setincorrectError(true);
        }
    };

    const role = "company"
    const SignUpHandler = async () => {
        const sideBar = sessionStorage.getItem('navBtn');
        setLoading(true)
        try {
            if (email != "" && email != null && email != undefined &&
                password != "" && password != null && password != undefined
            ) {
                if (email.includes("@") && password.length > 5) {
                    const isSignup = await dispatch(
                        authActions.signUp(email, password, name, role)
                    );
                    if (isSignup) {
                        setLoading(false)
                        console.log(isSignup)
                        // setState(4)
                        if (location?.state?.data === "toTemplate") {
                            navigateTo(`/templates`);
                        } else {
                            navigateTo("/on-boarding");
                        }
                    }
                    if (!isSignup) {
                        setLoading(false)
                        setincorrectError(true);
                    }
                }
                else {
                    setLoading(false)
                    setpasswordLengthError(true);
                    setTimeout(() => {
                        setpasswordLengthError(false);
                    }, 10000);
                }
            } else {
                setLoading(false)
                setpasswordLengthError(true);
                setTimeout(() => {
                    setpasswordLengthError(false);
                }, 10000);
            }
        } catch (e) {
            setLoading(false)
            alert("Network Error");
        }
    };

    const handleSignUpSubmit = (e) => {
        e.preventDefault();
        if (email?.startsWith('demo.evala')) {
            SignUpHandler()
        } else {
            switchToVerify()
        }
    }

    // Define the async function
    const fetchUserId = async () => {
        try {
            // setLoading(true); // Set loading to true at the beginning of the request
            const res = await backend.get(`/user?email=${email}`);
            console.log(res.data)
            setUserId(res?.data._id);
            // setFilteredFiles(res?.data);
            console.log(res?.data);
        } catch (error) {
            console.error("Failed to fetch user id:", error);
            // Handle error state as needed
        } finally {
            setLoading(false); // Set loading to false after the request is complete
        }
    };

    const resetLink = `https://www.pitchperfecter.ai/createpassword/${userId}/`;
    const ForgotHandler = async (e) => {
        e.preventDefault();
        setLoading(true)
        fetchUserId();

        try {
            const isforgot = await dispatch(authActions.forgotPassword(email, resetLink));
            if (isforgot) {
                setLoading(false)
                setinvalidEmailError(false);
                setemailSentMsg(true);
                setTimeout(() => {
                    setinvalidEmailError(false);
                    setemailSentMsg(false);
                }, 10000);
            } else {
                setLoading(false)
                setemailSentMsg(false);
                setinvalidEmailError(true);
                setTimeout(() => {
                    setinvalidEmailError(false);
                    setemailSentMsg(false);
                }, 10000);
            }
        } catch (err) {
            setLoading(false)
            alert('Network error')
        }
    }

    const onCLickVerify = async (e) => {
        e.preventDefault();
        setLoading(true);
        const encryptedDataFromStorage = sessionStorage.getItem('encryptedData');
        if (encryptedDataFromStorage) {
            const bytes = CryptoJS.AES.decrypt(encryptedDataFromStorage, 'secret-key');
            const decryptedData = bytes.toString(CryptoJS.enc.Utf8);

            if (userCode === decryptedData) {
                SignUpHandler();
            } else {
                setIncorrectCode(true);
                setLoading(false);
                setTimeout(() => {
                    setIncorrectCode(false);
                }, 1000);
            }
        }
    }

    useEffect(() => {
        if (location.state) {
            if (location?.state?.data === "toSignup") {
                switchToSignUp();
            }
        }
    }, [location.state]);

    const boxStyles = {
        // marginTop: "1rem",
        background: "white",
        padding: "40px",
        height: "auto",
        width: width > 800 ? "max-content" : "auto",
        borderRadius: "16px",
        boxShadow: "0 4px 8px rgba(16, 24, 40, 0.1)",
    };

    const MoveToSubdomain = () => {
        window.location.href = `https://${companyName}.evala.ai`;
    };

    return (
        <>
            <div className={Classes.signUp} >
                <div className={Classes.signUpGridLeft} >
                    <AnimatePresence mode="wait">
                        {state === "signup" && (
                            <motion.div
                                key='signup'
                                initial={{ opacity: 0, x: -10 }}
                                animate={{ opacity: 1, x: 0 }}
                                exit={{ opacity: 0, x: -10 }}
                                transition={{
                                    duration: 0.5,
                                    ease: easeOut,
                                    delay: 0.3
                                }}
                            >
                                <form onSubmit={handleSignUpSubmit} className={Classes.signUpInnerCon}>
                                    <a href="/" className={Classes.miniLogo2} style={{ textDecoration: 'none' }} >
                                        <Logo />
                                    </a>
                                    <h5 className={Classes.heading2} >Sign up</h5>
                                    <p className={Classes.subtitle} style={{ textAlign: 'start' }} >Create a free Anchorize account and build custom onboarding, workflow, and client management systems.</p>
                                    <input
                                        onChange={(e) => setCompanyName(e.target.value)}
                                        type="text"
                                        placeholder="Enter your company name"
                                        required
                                        className={`${`${Classes.inputField} ${Classes.mb10}`} ${incorrectError || userAlreadyExistError ? Classes.inputError : ''}`}
                                        style={{ width: '100%' }}
                                    />
                                    <input
                                        onChange={(e) => setName(e.target.value)}
                                        type="text"
                                        placeholder="Enter your name"
                                        required
                                        className={`${`${Classes.inputField} ${Classes.mb10}`} ${incorrectError || userAlreadyExistError ? Classes.inputError : ''}`}
                                        style={{ width: '100%' }}
                                    />
                                    <input
                                        onChange={(e) => setEmail(e.target.value)}
                                        type="email"
                                        placeholder="Enter your email"
                                        required
                                        className={`${`${Classes.inputField} ${Classes.mb10}`} ${incorrectError || userAlreadyExistError ? Classes.inputError : ''}`}
                                        style={{ width: '100%' }}
                                    />
                                    <div className={`${`${Classes.passwordCon} ${Classes.mb10}`} ${incorrectError || passwordMatchingError || passwordLengthError ? Classes.inputError : ''}`} >
                                        <input
                                            onChange={(e) => setPassword(e.target.value)}
                                            type={showEye ? "text" : "password"}
                                            placeholder="Enter your password"
                                            required
                                        />
                                        {showEye ?
                                            <>
                                                <svg onClick={() => { setshowEye(!showEye) }} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path d="M288 80c-65.2 0-118.8 29.6-159.9 67.7C89.6 183.5 63 226 49.4 256c13.6 30 40.2 72.5 78.6 108.3C169.2 402.4 222.8 432 288 432s118.8-29.6 159.9-67.7C486.4 328.5 513 286 526.6 256c-13.6-30-40.2-72.5-78.6-108.3C406.8 109.6 353.2 80 288 80zM95.4 112.6C142.5 68.8 207.2 32 288 32s145.5 36.8 192.6 80.6c46.8 43.5 78.1 95.4 93 131.1c3.3 7.9 3.3 16.7 0 24.6c-14.9 35.7-46.2 87.7-93 131.1C433.5 443.2 368.8 480 288 480s-145.5-36.8-192.6-80.6C48.6 356 17.3 304 2.5 268.3c-3.3-7.9-3.3-16.7 0-24.6C17.3 208 48.6 156 95.4 112.6zM288 336c44.2 0 80-35.8 80-80s-35.8-80-80-80c-.7 0-1.3 0-2 0c1.3 5.1 2 10.5 2 16c0 35.3-28.7 64-64 64c-5.5 0-10.9-.7-16-2c0 .7 0 1.3 0 2c0 44.2 35.8 80 80 80zm0-208a128 128 0 1 1 0 256 128 128 0 1 1 0-256z" /></svg>
                                            </>
                                            :
                                            <>
                                                <svg onClick={() => { setshowEye(!showEye) }} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><path d="M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zm151 118.3C226 97.7 269.5 80 320 80c65.2 0 118.8 29.6 159.9 67.7C518.4 183.5 545 226 558.6 256c-12.6 28-36.6 66.8-70.9 100.9l-53.8-42.2c9.1-17.6 14.2-37.5 14.2-58.7c0-70.7-57.3-128-128-128c-32.2 0-61.7 11.9-84.2 31.5l-46.1-36.1zM394.9 284.2l-81.5-63.9c4.2-8.5 6.6-18.2 6.6-28.3c0-5.5-.7-10.9-2-16c.7 0 1.3 0 2 0c44.2 0 80 35.8 80 80c0 9.9-1.8 19.4-5.1 28.2zm51.3 163.3l-41.9-33C378.8 425.4 350.7 432 320 432c-65.2 0-118.8-29.6-159.9-67.7C121.6 328.5 95 286 81.4 256c8.3-18.4 21.5-41.5 39.4-64.8L83.1 161.5C60.3 191.2 44 220.8 34.5 243.7c-3.3 7.9-3.3 16.7 0 24.6c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c47.8 0 89.9-12.9 126.2-32.5zm-88-69.3L302 334c-23.5-5.4-43.1-21.2-53.7-42.3l-56.1-44.2c-.2 2.8-.3 5.6-.3 8.5c0 70.7 57.3 128 128 128c13.3 0 26.1-2 38.2-5.8z" /></svg>
                                            </>
                                        }
                                    </div>
                                    <div className={`${`${Classes.passwordCon} ${Classes.mb10}`} ${incorrectError || passwordMatchingError || passwordLengthError ? Classes.inputError : ''}`} >
                                        <input
                                            onChange={(e) => setconfirmPassword(e.target.value)}
                                            type={showEye2 ? "text" : "password"}
                                            placeholder="Confirm password"
                                            required
                                        />
                                        {showEye2 ?
                                            <>
                                                <svg onClick={() => { setshowEye2(!showEye2) }} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path d="M288 80c-65.2 0-118.8 29.6-159.9 67.7C89.6 183.5 63 226 49.4 256c13.6 30 40.2 72.5 78.6 108.3C169.2 402.4 222.8 432 288 432s118.8-29.6 159.9-67.7C486.4 328.5 513 286 526.6 256c-13.6-30-40.2-72.5-78.6-108.3C406.8 109.6 353.2 80 288 80zM95.4 112.6C142.5 68.8 207.2 32 288 32s145.5 36.8 192.6 80.6c46.8 43.5 78.1 95.4 93 131.1c3.3 7.9 3.3 16.7 0 24.6c-14.9 35.7-46.2 87.7-93 131.1C433.5 443.2 368.8 480 288 480s-145.5-36.8-192.6-80.6C48.6 356 17.3 304 2.5 268.3c-3.3-7.9-3.3-16.7 0-24.6C17.3 208 48.6 156 95.4 112.6zM288 336c44.2 0 80-35.8 80-80s-35.8-80-80-80c-.7 0-1.3 0-2 0c1.3 5.1 2 10.5 2 16c0 35.3-28.7 64-64 64c-5.5 0-10.9-.7-16-2c0 .7 0 1.3 0 2c0 44.2 35.8 80 80 80zm0-208a128 128 0 1 1 0 256 128 128 0 1 1 0-256z" /></svg>
                                            </>
                                            :
                                            <>
                                                <svg onClick={() => { setshowEye2(!showEye2) }} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><path d="M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zm151 118.3C226 97.7 269.5 80 320 80c65.2 0 118.8 29.6 159.9 67.7C518.4 183.5 545 226 558.6 256c-12.6 28-36.6 66.8-70.9 100.9l-53.8-42.2c9.1-17.6 14.2-37.5 14.2-58.7c0-70.7-57.3-128-128-128c-32.2 0-61.7 11.9-84.2 31.5l-46.1-36.1zM394.9 284.2l-81.5-63.9c4.2-8.5 6.6-18.2 6.6-28.3c0-5.5-.7-10.9-2-16c.7 0 1.3 0 2 0c44.2 0 80 35.8 80 80c0 9.9-1.8 19.4-5.1 28.2zm51.3 163.3l-41.9-33C378.8 425.4 350.7 432 320 432c-65.2 0-118.8-29.6-159.9-67.7C121.6 328.5 95 286 81.4 256c8.3-18.4 21.5-41.5 39.4-64.8L83.1 161.5C60.3 191.2 44 220.8 34.5 243.7c-3.3 7.9-3.3 16.7 0 24.6c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c47.8 0 89.9-12.9 126.2-32.5zm-88-69.3L302 334c-23.5-5.4-43.1-21.2-53.7-42.3l-56.1-44.2c-.2 2.8-.3 5.6-.3 8.5c0 70.7 57.3 128 128 128c13.3 0 26.1-2 38.2-5.8z" /></svg>
                                            </>
                                        }
                                    </div>
                                    <div className={`${`${Classes.inputField} ${Classes.mb10}`}`} >
                                        <div className={Classes.textAlign} >
                                            <input
                                                type='color'
                                                value={colorScheme}
                                                onChange={(e) => setcolorScheme(e.target.value)}
                                            />
                                            <input
                                                type='text'
                                                value={colorScheme}
                                                onChange={(e) => { setcolorScheme(e.target.value); }}
                                                className={Classes.colorSchemeTextInput}
                                            />
                                        </div>
                                    </div>
                                    <div className={`${`${Classes.inputField} ${Classes.mb10}`}`} onClick={handleClick} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px', cursor: 'pointer' }} >
                                        <div className={Classes.flexBetween2} >
                                            <div>
                                                <h5 className={Classes.label3} >Upload logo</h5>
                                            </div>
                                            <div className={Classes.uploadMiddle} >
                                                <input
                                                    ref={imageInputRef}
                                                    hidden
                                                    accept="image/*"
                                                    type="file"
                                                    onChange={handleInputChange}
                                                    name="uploadBrochure"
                                                    id="formFile" />
                                                <svg height="20px" fill={'#0A84FF'} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
                                                    <path d="M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM216 408c0 13.3-10.7 24-24 24s-24-10.7-24-24V305.9l-31 31c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l72-72c9.4-9.4 24.6-9.4 33.9 0l72 72c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-31-31V408z" />
                                                </svg>
                                                {brochureLoading ? <h5>Loading...</h5> : null}
                                                {/* {imageURL && (
                                                <img
                                                    style={{ height: "3rem", width: 'max-content', margin: "3px", borderRadius: "6px" }}
                                                    src={imageURL}
                                                    alt="Uploaded Image"
                                                />
                                            )} */}
                                            </div>
                                            <div></div>
                                        </div>
                                    </div>
                                    <h5 className={Classes.label2} >Transparent PNG logo</h5>

                                    {incorrectError && <p className={Classes.error}>*Username or Password is incorrect.</p>}
                                    {passwordMatchingError && <p className={Classes.error}>*Passwords are not matching.</p>}
                                    {passwordLengthError && <p className={Classes.error}>*Enter correct email & password length greater than 5.</p>}
                                    {userAlreadyExistError && <p className={Classes.error}> {errorMessage} </p>}

                                    <p className={Classes.signupLink} style={{ maxWidth: '100%' }} >
                                        By creating an account, you agree to the
                                        <a href="/privacy-policy" target="_blank" >
                                            <button type="button" className={Classes.linkButton}>
                                                Privacy Policy
                                            </button>
                                        </a>
                                        and
                                        <a href="/terms-of-service" target="_blank" >
                                            <button type="button" className={Classes.linkButton}>
                                                Terms of Service
                                            </button>
                                        </a>
                                    </p>
                                    <button type="submit" className={`${Classes.button} ${Classes.signInButton}`} disabled={loading} >
                                        Create an account
                                        {loading && <LoadingSpinner />}
                                    </button>
                                    <p className={Classes.signupLink2}>
                                        Have an account?
                                        <button type="button" onClick={switchToSignIn} className={Classes.linkButton}>
                                            Sign in
                                        </button>
                                    </p>
                                    {/* <div className={Classes.textWithLines}>
                      <hr />
                      <span>OR</span>
                      <hr />
                    </div>
                    <button className={Classes.button}>
                      <img src="/google.png" alt="google" className={Classes.googleIcon} />
                      <p className={Classes.googleText} > Continue with Google </p>
                    </button> */}
                                </form>
                            </motion.div>
                        )}
                        {state === "verify" && (
                            <motion.div
                                key='verify'
                                initial={{ opacity: 0, x: -10 }}
                                animate={{ opacity: 1, x: 0 }}
                                exit={{ opacity: 0, x: -10 }}
                                transition={{
                                    duration: 0.5,
                                    ease: easeOut,
                                    delay: 0.3
                                }}
                            >
                                <form onSubmit={onCLickVerify} className={Classes.signUpInnerCon}>
                                    <a href="/" className={Classes.miniLogo2} >
                                        <img src="/site.png" alt="logo" />
                                    </a>
                                    <h1 className={Classes.heading2}>Enter verification code</h1>
                                    {codeSentMsg && <p className={Classes.subtitle} style={{ textAlign: 'start' }} > A code was sent to your email </p>}
                                    <br />
                                    <input
                                        onChange={(e) => setUserCode(e.target.value)}
                                        type="number"
                                        value={userCode}
                                        placeholder="Enter your code here"
                                        required
                                        className={`${`${Classes.inputField} ${Classes.mb10}`} ${incorrectError ? Classes.inputError : ''}`}
                                        style={{ width: '100%' }}
                                    />
                                    {IncorrectCode && <p className={Classes.error}>*Incorrect code.</p>}
                                    <button type="submit" className={`${Classes.button} ${Classes.signInButton}`} disabled={loading} >
                                        Verify
                                        {loading && <LoadingSpinner />}
                                    </button>
                                    <p className={Classes.signupLink2}>
                                        Haven't received the code?
                                        <button type="button" onClick={() => switchToVerify()} className={Classes.linkButton}>
                                            Resend code
                                        </button>
                                    </p>
                                    <p onClick={() => setState("signin")} className={Classes.signupLink2} style={{ cursor: 'pointer' }} >
                                        Back to sign in page?
                                    </p>
                                </form>
                            </motion.div>
                        )}
                    </AnimatePresence>
                </div>
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{
                        duration: 0.3,
                        ease: easeOut,
                    }}
                    className={Classes.signUpGridRight}
                >
                    <motion.div
                        initial={{ opacity: 0, x: 10 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{
                            duration: 0.5,
                            ease: easeOut,
                            delay: 0.3
                        }}
                        className={Classes.signUpInnerCon2}
                    >
                        <h5 className={Classes.title3} > Start today for free </h5>
                        <div className={Classes.flexAlign2} >
                            <svg xmlns="http://www.w3.org/2000/svg" height="15px" fill="white" viewBox="0 0 512 512"><path d="M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z" /></svg>
                            <h5 className={Classes.miniText} >No credit card required</h5>
                        </div>
                        <div className={Classes.infoElem} >
                            <div className={Classes.infoImgBox} >
                                <img src='/assets/icons/signup1.png' alt="img" />
                            </div>
                            <div className={Classes.infoElemRight} >
                                <h5 className={Classes.title5} >Client Onboarding & Management</h5>
                                <h5 className={Classes.miniText2} >Effortlessly onboard and manage clients with custom workflow and intake forms—no more disorganized processes.</h5>
                            </div>
                        </div>
                        <div className={Classes.infoElem} >
                            <div className={Classes.infoImgBox} >
                                <img src='/assets/icons/signup2.png' alt="img" />
                            </div>
                            <div className={Classes.infoElemRight} >
                                <h5 className={Classes.title5} >Automated Workflows</h5>
                                <h5 className={Classes.miniText2} >Streamline tasks and communications with custom-built workflows, ensuring every client follows the right steps automatically.</h5>
                            </div>
                        </div>
                        <div className={Classes.infoElem} >
                            <div className={Classes.infoImgBox} >
                                <img src='/assets/icons/signup3.png' alt="img" />
                            </div>
                            <div className={Classes.infoElemRight} >
                                <h5 className={Classes.title5} >All-in-One Client Hub</h5>
                                <h5 className={Classes.miniText2} > Centralize client data, tasks, and messaging in one place—eliminating scattered emails and lost information. </h5>
                            </div>
                        </div>
                        <div className={Classes.infoElem} >
                            <div className={Classes.infoImgBox} >
                                <img src='/assets/icons/signup4.png' alt="img" />
                            </div>
                            <div className={Classes.infoElemRight} >
                                <h5 className={Classes.title5} >Cost-Effective & Scalable</h5>
                                <h5 className={Classes.miniText2} > Reduce admin workload and cut costs with automation, allowing your team to focus on strategic work instead of manual processes. </h5>
                            </div>
                        </div>
                    </motion.div>
                </motion.div>
            </div>
        </>
    );
}

export default Signup;
